// ============================================
// useNotificationPrefs — préférences de notifications
// Persiste dans localStorage, synchronisé entre composants via CustomEvent
// ============================================
import { useState, useCallback, useEffect } from 'react';
const STORAGE_KEY = 'notif_prefs_v1';
const PREFS_CHANGED_EVENT = 'notif-prefs-changed';
export const DEFAULT_PREFS = {
    EXERCISE_COMPLETED: true,
    EXERCISE_FAILED: true,
    SCREEN_TIME_LIMIT: true,
    STATS_STREAK: true,
    STATS_POOR: true,
    ACCOUNT_LINKED: true,
    BADGE_EARNED: true,
};
function readPrefs() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? { ...DEFAULT_PREFS, ...JSON.parse(stored) } : { ...DEFAULT_PREFS };
    }
    catch {
        return { ...DEFAULT_PREFS };
    }
}
export function useNotificationPrefs() {
    const [prefs, setPrefs] = useState(readPrefs);
    // Sync with other mounted instances of this hook in the same tab
    useEffect(() => {
        const onChanged = () => setPrefs(readPrefs());
        window.addEventListener(PREFS_CHANGED_EVENT, onChanged);
        return () => window.removeEventListener(PREFS_CHANGED_EVENT, onChanged);
    }, []);
    const updatePref = useCallback((type, value) => {
        setPrefs(prev => {
            const next = { ...prev, [type]: value };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            window.dispatchEvent(new CustomEvent(PREFS_CHANGED_EVENT));
            return next;
        });
    }, []);
    // isEnabled: true by default for unknown types
    const isEnabled = useCallback((type) => prefs[type] !== false, [prefs]);
    return { prefs, updatePref, isEnabled };
}
//# sourceMappingURL=useNotificationPrefs.js.map